"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _Message = require("../message/Message");
var _dayPickerSelectedDayModule = _interopRequireDefault(require("./day-picker-selected-day.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DayPickerSelectedDay = function DayPickerSelectedDay(_ref) {
  var _ref$additionalInform = _ref.additionalInformationOnSelect,
    additionalInformationOnSelect = _ref$additionalInform === void 0 ? undefined : _ref$additionalInform,
    _ref$selectedDayMessa = _ref.selectedDayMessageTitle,
    selectedDayMessageTitle = _ref$selectedDayMessa === void 0 ? undefined : _ref$selectedDayMessa,
    _ref$selectedDayMessa2 = _ref.selectedDayMessageBody,
    selectedDayMessageBody = _ref$selectedDayMessa2 === void 0 ? undefined : _ref$selectedDayMessa2,
    _ref$selectedDayMessa3 = _ref.selectedDayMessageType,
    selectedDayMessageType = _ref$selectedDayMessa3 === void 0 ? 'information' : _ref$selectedDayMessa3,
    _ref$selectedDayMessa4 = _ref.selectedDayMessageRole,
    selectedDayMessageRole = _ref$selectedDayMessa4 === void 0 ? 'alert' : _ref$selectedDayMessa4,
    _ref$selectedDayMessa5 = _ref.selectedDayMessageClassName,
    selectedDayMessageClassName = _ref$selectedDayMessa5 === void 0 ? undefined : _ref$selectedDayMessa5,
    _ref$focusOnSelectedD = _ref.focusOnSelectedDayMessage,
    focusOnSelectedDayMessage = _ref$focusOnSelectedD === void 0 ? true : _ref$focusOnSelectedD,
    _ref$selectedDay = _ref.selectedDay,
    selectedDay = _ref$selectedDay === void 0 ? undefined : _ref$selectedDay;
  var containerRef = (0, _react.useRef)(null);
  var focusOnMessage = function focusOnMessage() {
    if (focusOnSelectedDayMessage && containerRef.current) {
      var message = containerRef.current.querySelector('div[role="alert"]');
      if (message !== null && message !== void 0 && message.focus) {
        message.focus();
      }
    }
  };
  (0, _react.useEffect)(function () {
    focusOnMessage();
  }, [selectedDay]);
  var messageType = selectedDayMessageType;
  var DEPRECATED_MESSAGE_TYPES = {
    info: 'information'
  };
  if (DEPRECATED_MESSAGE_TYPES[messageType]) {
    console.warn("DayPickerSelectedDay: A deprecated message type has been used \"".concat(selectedDayMessageType, "\"."));
    messageType = DEPRECATED_MESSAGE_TYPES[messageType];
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: containerRef,
    "data-jlds": true,
    children: [selectedDayMessageTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message.Message, {
      body: selectedDayMessageBody,
      title: selectedDayMessageTitle,
      type: messageType,
      className: (0, _classnames["default"])(_dayPickerSelectedDayModule["default"]['c-selectedDayMessage'], selectedDayMessageClassName),
      role: selectedDayMessageRole
    }), additionalInformationOnSelect && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      "data-testid": "day-picker-additional-information",
      children: additionalInformationOnSelect
    })]
  });
};
DayPickerSelectedDay.propTypes = {
  /** Selected day in the YYYY-MM-DD format */
  selectedDay: _propTypes["default"].string,
  /** Additional information to show on day select */
  additionalInformationOnSelect: _staticContentPropCheck["default"],
  /** Title text to show on day select */
  selectedDayMessageTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  /** Body text to show on day select */
  selectedDayMessageBody: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  /** Message type */
  selectedDayMessageType: _propTypes["default"].string,
  /** Message role */
  selectedDayMessageRole: _propTypes["default"].string,
  /** Optional class name */
  selectedDayMessageClassName: _propTypes["default"].string,
  /** Enable autofocus on selected day message, defaults to true */
  focusOnSelectedDayMessage: _propTypes["default"].bool
};
var _default = exports["default"] = DayPickerSelectedDay;